/* eslint-disable */
import axios from "axios";
import store from "@/store";
import moment from "moment";
import monitorKpiModal from "../monitor-kpi-modal/monitor-kpi-modal.vue";
import CreateSchedulePopup from "../RAC_Insight/CreateSchedulePopup.vue";

export default {
  name: "SiteOverviewBootstrap",
  components: {
    monitorKpiModal,
    CreateSchedulePopup,
  },

  data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      privilagedsites: [],
      performanceList: [],
      kpiWithScores: [],
      openModal: false,
      createschedulemodel: false,
      siteId: "",
      siteCodeforpopup: "",
      studies: [
        { id: "PC-301", name: "NeuroBloc - Phase III", status: "active", enrollment: { actual: 32, target: 40 }, subjects: { screened: 45, enrolled: 32, completed: 18 }, queries: 8, monitoringVisit: "2023-05-22" },
        { id: "PC-245", name: "CardioSafe - Phase II", status: "active", enrollment: { actual: 28, target: 30 }, subjects: { screened: 35, enrolled: 28, completed: 22 }, queries: 5, monitoringVisit: "2023-05-18" },
        { id: "PC-312", name: "ArthroFlex - Phase III", status: "active", enrollment: { actual: 40, target: 50 }, subjects: { screened: 52, enrolled: 40, completed: 30 }, queries: 6, monitoringVisit: "2023-06-05" },
        { id: "PC-228", name: "OncoTarget - Phase II", status: "hold", enrollment: { actual: 22, target: 25 }, subjects: { screened: 30, enrolled: 22, completed: 15 }, queries: 3, monitoringVisit: "TBD" },
        { id: "PC-198", name: "DermaHeal - Phase III", status: "closeout", enrollment: { actual: 20, target: 20 }, subjects: { screened: 25, enrolled: 20, completed: 20 }, queries: 1, monitoringVisit: "2023-05-30" },
      ],
      querycount:0,
      monitoringvisitscount:0,
        };
  },

  computed: {
    metricsAll() {
      return [
        { key: "activeStudies", label: "Active Studies", value: new Set(this.privilagedsites.map((s) => (s.studyId !== null && s.studyId !== undefined ? s.studyId : s.studyRef)).filter((v) => v !== null && v !== undefined && String(v).trim() !== "")).size, bg: "bg-blue-soft", fa: "fas fa-clipboard-list" },
        { key: "totalEnrolled", label: "Enrolled Subjects", value: this.privilagedsites.reduce((sum, s) => sum + (Number(s.actullyEnrolled) || 0), 0), bg: "bg-green-soft", fa: "fas fa-users" },
        { key: "openQueries", label: "Open Queries", value: Number(this.querycount) || 0, bg: "bg-yellow-soft", fa: "fas fa-question-circle" },
        { key: "monitoring", label: "Next Month CRA Visits", value: Number(this.monitoringvisitscount) || 0, bg: "bg-secondary-soft", fa: "fas fa-calendar-check" },
      ];
    },
  },

  async mounted() {
    this.getprivilagedsites();
    this.listSitePerformance();
    this.getquerycount();
    this.getmonitoringvisits();
    window.addEventListener("studyIdChanged", this.handleStudyIdChanged);
  },

  beforeDestroy() {
    window.removeEventListener("studyIdChanged", this.handleStudyIdChanged);
  },

  methods: {
    handleStudyIdChanged() {
      this.getprivilagedsites();
      this.listSitePerformance();
      this.getquerycount();
      this.getmonitoringvisits();
    },
    async getprivilagedsites() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(`${this.baseapi}/management/site/getprivilagedsites`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        console.log("getprivilagedsites:", response.data);
        this.privilagedsites = response.data;
      } catch (error) {
        console.error("Error fetching Study Arms:", error);
      }
    },
    async listSitePerformance() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      try {
        const response = await axios.get(
          `${this.baseapi}/forms/rbqm/getriskscorestudysitesummary?studyId=${studyId}&isPrivileged=true`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.performanceList = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error("Error fetching site performance:", error);
        this.performanceList = [];
      }
    },
async getquerycount() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseapi}/forms/query/getcounts`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        if (typeof response.data === "number") {
          this.querycount = response.data;
        } else if (response.data && typeof response.data === "object") {
          this.querycount =
            Number(response.data.totalCount) ||
            Number(response.data.openQuries) ||
            Number(response.data.openQueries) ||
            0;
        } else {
          this.querycount = 0;
        }
      } catch (error) {
        console.error("Error fetching site performance:", error);
        this.querycount = 0;
      }
    },
    async getmonitoringvisits() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseapi}/forms/cra/craschedulelist?IsSiteprivilege=true`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.monitoringvisitscount = Number(response.data?.totalCount) || 0;
      } catch (error) {
        console.error("Error fetching site performance:", error);
        this.monitoringvisitscount = 0;
      }
    },
    hasExpectedTotal(s) {
      const t = Number(s?.expectedTotalSubjects);
      return Number.isFinite(t) && t > 0;
    },

    enrollmentPercentSite(s) {
      const a = Number(s?.actullyEnrolled);
      const t = Number(s?.expectedTotalSubjects || 0);
      if (!Number.isFinite(a) || !Number.isFinite(t) || t <= 0) return 0;
      return Math.max(0, Math.min(100, Math.round((a / t) * 100)));
    },

    progressBarClass(percent) {
      if (percent < 60) return "bg-danger";
      if (percent < 80) return "bg-warning";
      return "bg-success";
    },
    customcolor(score) {
      var intscore = parseInt(score, 10);
      if (intscore >= 20) return "inround highrisk";
      if (intscore >= 10) return "inround mediumrisk";
      return "inround safe";
    },
    formatRunDate(date) {
      if (!date) return "-";
      return moment.utc(date).local().format("DD-MM-YYYY");
    },
    viewDocument(kpiWithScores, siteId, siteCode) {
      this.siteCodeforpopup = siteCode || "";
      this.siteId = siteId || "";
      this.kpiWithScores = kpiWithScores;
      this.openModal = true;
    },
    opencreateschdule() {
      this.createschedulemodel = true;
    },
    closeModal() {
      this.openModal = false;
    },
  },
};
